function openCloseFilterDOM(){
  return(`
    <select class="form-control form-control-sm me-2" id="dt-filter-status">
      <option value="all" selected>All</option>
      <option value="open">Open</option>
      <option value="closed">Closed</option>
    </select>
  `)
}

window.showLoadingRow = function (elm, cs) {
  var loadingRow = `<tr id="loading-row"><td colspan="${cs}" class="text-center"><div class="spinner-border spinner-border-sm text-primary" role="status"></div></td></tr>`;
  $(`${elm} tbody`).html(loadingRow);
}

window.hideLoadingRow = function () {
  $('#loading-row').remove();
}

window.dtFinalTouch = function (option = null) {
  $('.dt-length').find('label').remove()
  $('.dt-length').find('select').addClass("py-0")
  $('.dt-search').find('label').remove()
  $('.dt-info').addClass("fs-12")
  $('.dt-layout-table').addClass('overflow-auto')
  $('.dataTable').addClass("pt-2")
  $('.dataTable').attr("style", "border-top: 1px solid #E6EAED")

  if (option.singleDateFilter) {
    $(".dt-search").addClass("d-flex")
    $(".dt-search").prepend(dtSingleDateFilter)
  }

  if (option.openCloseFilter) {
    $(".dt-search").addClass("d-flex")
    $(".dt-search").prepend(openCloseFilterDOM)
  }
}

import "./master_data"
import "./report"